export default {
  'dbi-sm-data-summary': 'Data Summary',
  'dbi-sm-historical-magnitude': 'Historical Magnitude',
  'dbi-sm-monthly-updated-games': 'Monthly Updated Games',
  'dbi-sm-countries-coverage': 'Markets Coverage',
  'dbi-sm-data-sources': 'Data Sources',
  'dbi-sm-top-games-coverage': 'Top Games Coverage',
  'dbi-sm-company-coverage': 'Company Coverage',
  'dbi-sm-news': 'News',
  'dbi-sm-social-media-opinions': 'Social Media Opinions',
  'dbi-sm-game-store-comments': 'Game Store Comments',
  'dbi_sm_revenue_heat_map': 'Revenue Heat Map',
  'dbi_sm_all_games': 'All Games',
  'dbi_sm_MOBILE': 'TOP MOBILE\nGAMES',
  'dbi_sm_PC': 'TOP PC\nGAMES',
  'dbi_sm_CONSOLE': 'TOP CONSOLE\nGAMES',
  'dbi_sm_top_company': 'TOP\nCOMPANY',

  'dbi-sm-sources': 'Sources',
  'dbi-sm-intelligence-sources': 'Intelligence Sources',
  'dbi-sm-opinions-sources': 'Opinions Sources',
  'dbi-sm-news-crawlers': 'News Crawlers',
  'dbi-sm-metrics': 'Metrics',
  'dbi-sm-intelligence-metrics': 'Intelligence Metrics',
  'dbi-sm-opinions-metrics': 'Opinions Metrics',
  'dbi-sm-mobile-game-fields': 'Mobile Game Fields',
  'dbi-sm-PC&Console': 'PC & Console Game Fields',
  'dbi-sm-company-fields': 'Company Fields',
  'dbi-sm-device-metrics': 'Device Metrics',

  'dbi-sm-filter-datasource': 'Data Source',
  'dbi-sm-filter-gametype': 'Game Type',
  'dbi-sm-filter-metrics': 'Metrics',
  'dbi-sm-filter-servicetype': 'Service Type',
  'dbi-sm-filter-channeltype': 'Channel Type',
  'dbi-sm-filter-granularity': 'Granularity',
  'dbi-sm-filter-frequency': 'Update Frequency',
  'dbi-sm-filter-gamestore': 'Game Store',
  'dbi-sm-filter-socialmedia': 'Social Media',
  'dbi-sm-filter-streaming': 'Streaming',

  'dbi-sm-filter-hour': 'Hour',
  'dbi-sm-filter-quarter': 'Quarter',
  'dbi-sm-filter-alltime': 'All Time',

  'dbi-sm-filter-acquisition': 'Data acquisition',
  'dbi-sm-filter-crawling': 'Data crawling',

  'dbi-sm-filter-mobile': 'Mobile',
  'dbi-sm-filter-pc': 'PC',
  'dbi-sm-filter-console': 'Console',

  'dbi-sm-table-description': 'Description',
  'dbi-sm-table-progress': 'Progress',
  'dbi-sm-table-sourceurl': 'Source url',
  'dbi-sm-table-summary': 'Service Summary',
  'dbi-sm-table-industry-coverage': 'Industry Coverage',
  'dbi-sm-table-rawdata': 'Raw Data',
  'dbi-sm-table-profitmodel': 'Profit Model',
  'dbi-sm-table-datausage': 'Data Usage (Internal Use Only)',
  'dbi-sm-table-note': 'Note',
  'dbi-sm-table-dateupdate': 'Data Update',
  'dbi-sm-table-actions': 'Actions',

  'dbi-sm-table-monitored': 'Game monitored',
  'dbi-sm-table-monthlyupdate': 'Monthly updated games',
  'dbi-sm-table-totalgames': 'Total games',
  'dbi-sm-table-comment': 'Monthly Comment update',
  'dbi-sm-table-feature': 'Source Feature',
  'dbi-sm-table-engagement': 'Metric/Engagement',
  'dbi-sm-table-availability': 'Availability',
  'dbi-sm-table-url': 'url',

  'dbi-sm-table-servicemodel': 'Service Model',

  'dbi-sm-table-definition': 'Metric definition',
  'dbi-sm-table-countries': 'Covered countries',
  'dbi-sm-table-historical': 'Historical data',
  'dbi-sm-table-metrics-cn': 'Metrics in Chinese',
  'dbi-sm-table-datagranularity': 'Data Granularity',
  'dbi-sm-games-coverage-tip': ` Top Games: The games listed on the
  major game store ranks in the month.
  Mobile ranks are from AppStore and
  GooglePlay, PC ranks are from Steam
  and Epic, and Console ranks are from
  Xbox.`,
  'dbi-sm-company-coverage-tip':
    'Top Companies: The companies which published the top games',
  'dbi-sm-table-fieldsName': 'Fields Name',
  'dbi-sm-table-fieldsdefinition': 'Fields definition',
  'dbi-sm-table-aggregation': 'Aggregation Logic',
  'dbi-sm-filter-fieldsdefinition': 'Fields Deifition',
  'dbi-sm-filter-fieldsName': 'Fields Name',
  'dbi-sm-filter-description': 'Description',
  'dbi-sm-filter-aggregation': 'Aggregation Logic',
  'dbi-sm-device-metrics-table-metric': 'Metrics',
  'dbi-sm-device-metrics-table-definition': 'Definition',
  'dbi-sm-device-metrics-table-description': 'Notes',

  'dbi-sm-revenue': 'Revenue',
  'dbi_sm_mobile_game_field_info1': '1. The current data sources are Crowdsourcing, App Store, Google Play, data.ai, Sensor Tower, Taptap.',
  'dbi_sm_mobile_game_field_info2': '2. The default priority of the data sources selected for the field are Crowdsourcing＞App Store＞Google Play＞data.ai＞Sensor Tower＞Taptap',
  'dbi_sm_mobile_game_field_info3': '3. Fields that do not require sorting, take the union of data from all data sources.',
  'dbi_sm_pc_game_field_info1': '1. PC Data Source Crowdsourcing, Steam, Vgchartz, Metacritic, Epgame, Vgtime, Gog, Origin, Opencritic; Console Data Source Crowdsourcing, Vgchartz, Metacritic, Xbox, Vgtime.',
  'dbi_sm_pc_game_field_info2': '2. Default Priority for PC Crowdsourcing＞Steam＞Metacritic > Vgchartz > Gog > Opencritic > Origin > Epic Game > Vgtime',
  'dbi_sm_pc_game_field_info3': '3. Default Priority for Console Crowdsourcing＞Vgchartz＞Metacritic＞Vgtime > Xbox > Opencritic > Nintendo',
  'dbi_sm_pc_game_field_info4': '4. Fields that do not require sorting, take the union of data from all data sources.',
  'dbi_sm_company_field_info1': '1. Company Data Source Priority: Crowdsouring＞Crunchbase＞data.ai＞Gamedevmap＞Gamebiz＞Mobygames > Pitchbook > Local > Spider',
  'dbi_sm_company_field_info2': '2. Crowdsourcing involves manually added whitelisted or specially monitored individuals, enforcing updates.',
  'dbi_sm_company_field_info3': `3. Crunchbase serves as the primary source due to its comprehensive fields. Data.ai's core fields are used for supplementary validation in the case of mobile games to ensure developer information accuracy.`,
};


